import React from "react";
import { Accordion } from "react-bootstrap";

const ReachTab = () => {
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="tab-content" id="home-tab-pane">
          <Accordion.Body className="height_set">
            <div className="about_content">
              <div className="safrititles pt-3 pb-0">
                <h5>How to Reach Satpura Tiger Reserve </h5>
              </div>
              <p></p>
              <p>
                <strong>By Road:</strong>
                <br />
                <br />
                Satpura Tiger Reserve can be reached by road from/via Bhopal
                (170kms), Jabalpur (250kms) cities. There are 03 entrances for
                Satpura Tiger reserve visit. First is close to Pachmarhi Hill
                station, Second and popular one is form Madhai Entrance gate
                which is about 100kms from Pachmarhi close to Sarangpur village.
                Madhai Entrance Gate is about 19 kms inside from
                Pipariya-Narmadapuram road. Diversion for Madhai is close to
                Sohagpur town. Third Entrance is for those who are staying in MP
                Tourism: Tawa Resort located on Tawa Dam. It is close from
                Narmadapuram town. In order to reach Satpura, we recommend large
                cars with good ground clearance feature as approaching roads is
                muddy, rough and often poses great problem during rainy seasons.
                At the same time, due to lack of sigh-boards, consult local
                villagers or resort manager to reach the resort comfortably. The
                third wildlife destination Churna forest is located on
                Narmadapuram- Itarasi-Bhaura-Betul road. The tourist can reach
                Churna, which is 50 km inside STR from Bhoura. Tourist have to
                travel 50km from Bhoura to reach Churna rest House.
                <br /> <br />
                <strong>By Flight:</strong>
                <br />
                <br />
                There are two improtant airport for reaching STR. Nearest one is
                Bhopal airport(220kms) and second one is Jabalpur airport have
                direct Flight connectivity with Delhi and Mumbai. Even Nagpur
                can be used to reach Satpura.
                <br />
                <br />
                <strong>By Railway:</strong>
                <br />
                <br />
                Nearest railway station for satpura Tiger Reserve are:- Itarsi,
                Sohagpur, Pipariya and Narmadapuram.
              </p>
              <p></p>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default ReachTab;
